module.exports = __webpack_public_path__ + "img/milestone-asset-4.358c3370.png";